import { render, staticRenderFns } from "./KamuAktifDetay.vue?vue&type=template&id=99cc4f38&scoped=true"
import script from "./KamuAktifDetay.vue?vue&type=script&lang=ts"
export * from "./KamuAktifDetay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cc4f38",
  null
  
)

export default component.exports